import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  approvalLeaveApi,
  approveLeaveAllApi,
  getHistoryLeavesApi,
  getLeaveReportApi,
  getLeavesApi,
  uploadCTAllowanceApi,
} from "./leaveApi";

interface IInitialState {
  histories: any[];
  leaves: any[];
  message: string;
  pageIsLoading: boolean;
  isSuccess: boolean;
  uploadCTAllowance: any;
  reportLeaves: any[];
  approveLeaves: any;
  approveAll: any;
}

const initialState: IInitialState = {
  histories: [],
  reportLeaves: [],
  leaves: [],
  message: "",
  pageIsLoading: false,
  isSuccess: false,
  uploadCTAllowance: null,
  approveLeaves: null,
  approveAll: null,
};

export const getLeavesRequest = createAsyncThunk(
  "getLeavesRequest/leave",
  async () => {
    try {
      const response = await getLeavesApi();
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const getLeavesHistoryRequest = createAsyncThunk(
  "getLeavesHistoryRequest/leave",
  async (payload: any) => {
    try {
      const response = await getHistoryLeavesApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const uploadCTAllowanceRequest = createAsyncThunk(
  "uploadCTAllowanceRequest/leave",
  async (payload: any) => {
    try {
      const response = await uploadCTAllowanceApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const getLeaveReportRequest = createAsyncThunk(
  "getLeaveReportRequest/leave",
  async (payload: any) => {
    try {
      const response = await getLeaveReportApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const approvalLeaveRequest = createAsyncThunk(
  "approvalLeaveRequest/leave",
  async (payload: any) => {
    try {
      const response = await approvalLeaveApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const approvalLeaveAllRequest = createAsyncThunk(
  "approvalLeaveAllRequest/leave",
  async () => {
    try {
      const response = await approveLeaveAllApi();
      return response;
    } catch (error) {
      throw error;
    }
  }
);

const leaveSlice = createSlice({
  name: "leave",
  initialState: initialState,
  reducers: {
    resetLeaveMessage: (state) => {
      state.message = "";
    },
    resetLeaveSuccess: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLeavesRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getLeavesRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.leaves = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getLeavesRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });

    // histories
    builder.addCase(getLeavesHistoryRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getLeavesHistoryRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.histories = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getLeavesHistoryRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });

    // upload ct allowance
    builder.addCase(uploadCTAllowanceRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(uploadCTAllowanceRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.uploadCTAllowance = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(uploadCTAllowanceRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });

    // get leave report
    builder.addCase(getLeaveReportRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getLeaveReportRequest.fulfilled, (state, action) => {
      console.log("AAAAA", action.payload.data);

      if (action.payload.status === 1000) {
        state.reportLeaves = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getLeaveReportRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });

    // approve leave
    builder.addCase(approvalLeaveRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(approvalLeaveRequest.fulfilled, (state, action) => {
      console.log("AAAAA", action.payload.data);

      if (action.payload.status === 1000) {
        state.approveLeaves = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(approvalLeaveRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });

    // approve leave all
    builder.addCase(approvalLeaveAllRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(approvalLeaveAllRequest.fulfilled, (state, action) => {
      console.log("AAAAA", action.payload.data);

      if (action.payload.status === 1000) {
        state.approveAll = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(approvalLeaveAllRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const { resetLeaveMessage, resetLeaveSuccess } = leaveSlice.actions;
export default leaveSlice.reducer;
